var PXData = /** @class */ (function () {
    function PXData() {
    }
    return PXData;
}());
export { PXData };
